var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1056 1.67262C15.9362 0.593992 14.3028 0 12.5 0C10.6876 0 9.04877 0.590398 7.88474 1.66236C6.70809 2.74612 6.13479 4.21904 6.2694 5.80952C6.53622 8.94736 9.33122 11.4999 12.5 11.4999C15.6688 11.4999 18.459 8.94787 18.73 5.81055C18.8664 4.23444 18.2895 2.7646 17.1056 1.67262ZM23.0766 22.9999H1.92337C1.64649 23.0029 1.37229 22.9533 1.12072 22.8544C0.869155 22.7556 0.646542 22.6101 0.469081 22.4285C0.0784666 22.0296 -0.078981 21.4849 0.0376023 20.934C0.5448 18.5303 2.12769 16.5111 4.6156 15.0937C6.82588 13.8353 9.62568 13.1428 12.5 13.1428C15.3743 13.1428 18.1741 13.8359 20.3844 15.0937C22.8723 16.5106 24.4552 18.5298 24.9624 20.9335C25.079 21.4843 24.9215 22.029 24.5309 22.4279C24.3535 22.6096 24.1309 22.7552 23.8794 22.8542C23.6278 22.9531 23.3536 23.0029 23.0766 22.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/Account.294de173ffd1800b2ed44f2021976e10.svg";
export { ForwardRef as ReactComponent };